// extracted by mini-css-extract-plugin
export default {"card":"BookCard_card__Iij96","content":"BookCard_content__Sbu0j","image":"BookCard_image__+9ZHZ","textCl":"BookCard_textCl__vMjpF","button":"BookCard_button__l86ps"};